import api from '../../services/api';
import { toRequest } from '../../utils/RequestUtils';
import { getApis } from './../../library/Apis';
import { NUMERO_NAO_INFORMADO } from './../../utils/ValidationUtils';

export const CLEARED_EMPRESA_ACTION = 'CLEARED_EMPRESA_ACTION';
export const LOADING_EMPRESA_ACTION = 'LOADING_EMPRESA_ACTION';
export const LOADED_EMPRESA_ACTION = 'LOADED_EMPRESA_ACTION';
export const CREATED_EMPRESA_ACTION = 'CREATED_EMPRESA_ACTION';
export const EDITED_EMPRESA_ACTION = 'EDITED_EMPRESA_ACTION';
export const REMOVED_EMPRESA_ACTION = 'REMOVED_EMPRESA_ACTION';
export const CHANGED_EMPRESA_EDITING_VALUE_ACTION =
  'CHANGED_EMPRESA_EDITING_VALUE_ACTION';
export const CLEARED_EMPRESAS_PAGE_ACTION = 'CLEARED_EMPRESAS_PAGE_ACTION';
export const LOADED_EMPRESAS_PAGE_ACTION = 'LOADED_EMPRESAS_PAGE_ACTION';
export const LOADING_ALL_EMPRESAS_ACTION = 'LOADING_ALL_EMPRESAS_ACTION';
export const LOADED_ALL_EMPRESAS_ACTION = 'LOADED_ALL_EMPRESAS_ACTION';
export const CLEARED_EMPRESA_BY_CPF_ASSESSOR_ACTION =
  'CLEARED_EMPRESA_BY_CPF_ASSESSOR_ACTION';
export const LOADING_EMPRESA_BY_CPF_ASSESSOR_ACTION =
  'LOADING_EMPRESA_BY_CPF_ASSESSOR_ACTION';
export const LOADED_EMPRESA_BY_CPF_ASSESSOR_ACTION =
  'LOADED_EMPRESA_BY_CPF_ASSESSOR_ACTION';
export const LOADING_EMPRESA_BY_COOPERATIVA_ACTION =
  'LOADING_EMPRESA_BY_COOPERATIVA_ACTION';
export const LOADED_EMPRESA_BY_COOPERATIVA_ACTION =
  'LOADED_EMPRESA_BY_COOPERATIVA_ACTION';
export const LOADED_EMPRESA_ASSESSORES = 'LOADED_EMPRESA_ASSESSORES';
export const LOADING_EMPRESA_BY_CNPJ = 'LOADING_EMPRESA_BY_CNPJ';
export const LOADED_EMPRESA_BY_CNPJ = 'LOADED_EMPRESA_BY_CNPJ';
export const LOADING_EMPRESA_BY_CNPJ_ASSESSORES_NECESSARIOS =
  'LOADING_EMPRESA_BY_CNPJ_ASSESSORES_NECESSARIOS';
export const LOADED_EMPRESA_BY_CNPJ_ASSESSORES_NECESSARIOS =
  'LOADED_EMPRESA_BY_CNPJ_ASSESSORES_NECESSARIOS';

const getEndpoint = (version) => {
  return getApis().apis.contrato + 'v' + version + '/empresa/';
};

export const clearEmpresaEditing = () => ({
  type: CLEARED_EMPRESA_ACTION,
  payload: null,
});

export const loadEmpresaById = (id, callbackSuccess, callbackError) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_EMPRESA_ACTION,
      payload: true,
    });
    toRequest(api.get, [`${getEndpoint(1)}${id}`], 'empresa').then(
      (resp) => {
        dispatch({
          type: LOADING_EMPRESA_ACTION,
          payload: false,
        });
        dispatch({
          type: LOADED_EMPRESA_ACTION,
          payload: {
            ...resp.data,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_EMPRESA_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

function setupEmpresa(empresa) {
  let empresaObj = {
    ...empresa,
  };
  delete empresaObj.cooperativa;
  if (!empresa.numero || empresa.numero.trim().length === 0) {
    empresaObj.numero = NUMERO_NAO_INFORMADO;
  }
  return empresaObj;
}

export const createEmpresa = (empresa, callbackSuccess, callbackError) => {
  let empresaObj = setupEmpresa(empresa);
  return (dispatch) => {
    toRequest(api.post, [`${getEndpoint(1)}`, empresaObj], 'save').then(
      (resp) => {
        dispatch({
          type: CREATED_EMPRESA_ACTION,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const editEmpresa = (empresa, callbackSuccess, callbackError) => {
  let empresaObj = setupEmpresa(empresa);
  return (dispatch) => {
    toRequest(
      api.put,
      [`${getEndpoint(1)}${empresaObj.id}`, empresaObj],
      'save'
    ).then(
      (resp) => {
        dispatch({
          type: EDITED_EMPRESA_ACTION,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const removeEmpresa = (id, callbackSuccess, callbackError) => {
  return (dispatch) => {
    toRequest(api.delete, [`${getEndpoint(1)}${id}`], 'save').then(
      (resp) => {
        dispatch({
          type: REMOVED_EMPRESA_ACTION,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const changeEmpresaEditingValue = (name, value) => {
  if (typeof value === 'string') {
    if (value.trim().length > 0) {
      return {
        type: CHANGED_EMPRESA_EDITING_VALUE_ACTION,
        payload: { name, value },
      };
    } else {
      return {
        type: CHANGED_EMPRESA_EDITING_VALUE_ACTION,
        payload: { name, value: '' },
      };
    }
  }
  return {
    type: CHANGED_EMPRESA_EDITING_VALUE_ACTION,
    payload: { name, value },
  };
};

export const clearEmpresasPageList = () => ({
  type: CLEARED_EMPRESAS_PAGE_ACTION,
  payload: null,
});

export const loadEmpresasPaginados = (
  postData,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    const ensureArray = (data) => (Array.isArray(data) ? data : []);
    postData.estados = ensureArray(postData.estados);
    postData.cidades = ensureArray(postData.cidades);
    const url = `${getEndpoint(1)}page?page=${postData.page}&size=${
      postData.size
    }`;
    const { ...bodyData } = postData;
    toRequest(api.post, [url, bodyData], 'empresasPaginado').then(
      (resp) => {
        dispatch({
          type: LOADED_EMPRESAS_PAGE_ACTION,
          payload: {
            ...resp.data,
            busca: postData.busca,
            page: postData.page,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp.data);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadEmpresasAssessores = (
  postData,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    const ensureArray = (data) => (Array.isArray(data) ? data : []);
    postData.estados = ensureArray(postData.estados);
    postData.cidades = ensureArray(postData.cidades);
    const url = `${getEndpoint(1)}assessores`;
    const {...bodyData } = postData;
    toRequest(api.post, [url, bodyData], 'assessores').then(
      (resp) => {
        dispatch({
          type: LOADED_EMPRESA_ASSESSORES,
          payload: {
            page: postData.page,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp.data);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadAllEmpresas = (callbackSuccess, callbackError) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_ALL_EMPRESAS_ACTION,
      payload: true,
    });

    toRequest(api.get, [getEndpoint(1) + 'todos'], 'allEmpresas').then(
      (resp) => {
        dispatch({
          type: LOADED_ALL_EMPRESAS_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_ALL_EMPRESAS_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_ALL_EMPRESAS_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadAllEmpresasByCooperativa = (
  cooperativa,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_EMPRESA_BY_COOPERATIVA_ACTION,
      payload: true,
    });

    toRequest(
      api.get,
      [`${getEndpoint(1)}cooperativa/${cooperativa}`],
      // [getEndpoint(1) + 'todos'],
      'allEmpresas'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_EMPRESA_BY_COOPERATIVA_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_EMPRESA_BY_COOPERATIVA_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_EMPRESA_BY_COOPERATIVA_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const clearEmpresaByCPFAssessor = () => ({
  type: CLEARED_EMPRESA_BY_CPF_ASSESSOR_ACTION,
  payload: null,
});

export const loadEmpresaByCPFAssessor = (
  cpfAssessor,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_EMPRESA_BY_CPF_ASSESSOR_ACTION,
      payload: true,
    });
    toRequest(
      api.get,
      [`${getEndpoint(1)}assessor/${cpfAssessor}`],
      'save'
    ).then(
      (resp) => {
        dispatch({
          type: LOADING_EMPRESA_BY_CPF_ASSESSOR_ACTION,
          payload: false,
        });
        dispatch({
          type: LOADED_EMPRESA_BY_CPF_ASSESSOR_ACTION,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: LOADING_EMPRESA_BY_CPF_ASSESSOR_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadEmpresaByCnpj = (
  cnpjEmpresa,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_EMPRESA_BY_CNPJ,
      payload: true,
    });
    toRequest(api.get, [`${getEndpoint(1)}find/${cnpjEmpresa}`], 'save').then(
      (resp) => {
        dispatch({
          type: LOADING_EMPRESA_BY_CNPJ,
          payload: false,
        });
        dispatch({
          type: LOADED_EMPRESA_BY_CNPJ,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: LOADING_EMPRESA_BY_CNPJ,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadEmpresaByCnpjComAcessoresNecessarios = (
  cnpjEmpresa,
  assessoresNecessarios,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_EMPRESA_BY_CNPJ_ASSESSORES_NECESSARIOS,
      payload: true,
    });
    toRequest(
      api.post,
      [
        `${getEndpoint(1)}find/${cnpjEmpresa}`,
        {
          assessoresNecessarios: assessoresNecessarios || [],
        },
      ],
      'save'
    ).then(
      (resp) => {
        dispatch({
          type: LOADING_EMPRESA_BY_CNPJ_ASSESSORES_NECESSARIOS,
          payload: false,
        });
        dispatch({
          type: LOADED_EMPRESA_BY_CNPJ_ASSESSORES_NECESSARIOS,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: LOADING_EMPRESA_BY_CNPJ_ASSESSORES_NECESSARIOS,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};
